import usePostData from '../../../../../hooks/postHook';

export const useCompleteProcessing = () => {
  const [{ data, body, isLoading, isError }, completeProcessing] = usePostData(
    `office_parcels/processing_done`
  );
  return { data, body, isLoading, isError, completeProcessing };
};
